var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"element",staticClass:"p-3 text-center d-flex justify-content-center"},[(_vm.isLoading)?_c('v-loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }